import React, { FC } from 'react';
import { Divider as MDivider } from '@mantine/core';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface Props {
  my?: number | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'none';
  orientation?: 'horizontal' | 'vertical';
  color?: 'light-pink' | 'light-purple' | 'gray';
  className?: string;
  size?: number;
}

const Divider: FC<Props> = ({
  my = 'sm',
  orientation = 'horizontal',
  color = 'light-pink',
  className,
  size = 1,
}: Props): JSX.Element => {
  return (
    <MDivider
      size={size}
      my={my}
      orientation={orientation}
      className={classNames(styles.button, className, {
        [styles[`divider_color_${color}`]]: color,
      })}
    />
  );
};

export default Divider;
